// The second step of an emailed sign-in link. The link lands here without spending anything, since
// mail scanners open links before people do (some run scripts too, but none press buttons); the
// button spends it. The token comes in the fragment, so it never reaches a server log or a Referer.
import type { EmailVerifyRequest } from '@wbwl/contract'
import { useState } from 'react'
import { Navigate, useNavigate } from 'react-router'
import { Logo, useToast } from '../components/shell.tsx'
import { ApiFailure, api } from '../lib/api.ts'
import { useMe } from '../lib/data.ts'

const EXPIRED = '/signin?error=expired'

export default function SignInConfirmPage() {
  const me = useMe().data
  const navigate = useNavigate()
  const toast = useToast()
  const [token] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get('token') ?? '')
  const [busy, setBusy] = useState(false)

  async function confirm() {
    setBusy(true)
    try {
      await api.post('/auth/email/verify', { token } satisfies EmailVerifyRequest)
      // A full load, so every screen starts over as the account; replace, so Back skips the spent link.
      window.location.replace('/?signin=ok')
    } catch (err) {
      if (err instanceof ApiFailure && err.body.error === 'expired') {
        navigate(EXPIRED, { replace: true })
      } else {
        toast('Couldn’t sign in. Try again.')
        setBusy(false)
      }
    }
  }

  if (!token) return <Navigate to={EXPIRED} replace />
  return (
    <div className="page signin">
      <div className="signin-body">
        <Logo height={24} />
        <h1 className="h-serif">One more<br /><i>tap.</i></h1>
        <p className="muted">{me?.kind === 'member' ? 'This switches this device to the account the link was sent to.' : 'Finish signing in on this device. The games you’ve played here come with you.'}</p>
        <div className="signin-actions">
          <button className="btn ink block" type="button" onClick={confirm} disabled={busy}>Sign in to Letters on Fire</button>
        </div>
        <p className="faint small center">Didn’t ask for this link? Close this page and nothing happens.</p>
      </div>
    </div>
  )
}
